import { resourceSelectors } from '../../utils/resourceSelectors';

export const [webinarsAllIds, webinarsById, allWebinarsSelector] =
  resourceSelectors('webinars');
